import React from 'react';
import convert from 'htmr';
import styled from 'styled-components';
import { Paragraph } from '../components/Styling';

const transform = {
  p: Paragraph
};

const ContentWrapper = styled.div`
  max-width: ${props => props.maxWidth ? props.maxWidth : 'initial'};
`;

export default class HTMLtoJSX extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <ContentWrapper maxWidth={this.props.maxWidth}>
        {convert(this.props.content, { transform })}
      </ContentWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/HTMLtoJSX.js